The icon images to indicate candidate identity has been verified.
